import type {
	FeedPage,
	FetchShortsOptions
} from '~/composables/shorts/useFetchShorts';
import type { ShortsFilters } from '~/core/entities/property/filters';

import { useShortsFeedStore } from '~/store/shortsFeedStore';

/**
 * Adaptador sobre a lista do feed. A lógica toda mora em `useFeedSession`, via
 * `useShortsFeedStore`; isto aqui só mantém os nomes que as telas já usam.
 */
export function useFeedState() {
	const store = useShortsFeedStore();

	async function fetchFeed(
		filters?: ShortsFilters,
		options: FetchShortsOptions = {}
	): Promise<void> {
		await store.load(filters ?? {}, options);
	}

	async function loadMore(): Promise<void> {
		await store.loadMore();
	}

	async function applyFilters(
		filters: ShortsFilters,
		options: FetchShortsOptions = {}
	): Promise<void> {
		// Esvazia antes de buscar: trocar filtro não deve deixar no ar uma lista
		// que não corresponde mais ao que a barra mostra.
		store.reset();
		await store.load(filters, options);
	}

	function reset(): void {
		store.reset();
	}

	/**
	 * Popula o feed com itens que a tela de origem já tinha, sem request. O
	 * `loadMore` seguinte continua da página informada.
	 */
	function seedFromCarousel(page: FeedPage): void {
		store.seed(page);
	}

	return { fetchFeed, loadMore, applyFilters, reset, seedFromCarousel };
}
